module.exports = __webpack_public_path__ + "img/weather_1.64932ec6.jpg";